import type { KnownApiError } from "src/api/generated/errors/knownApiError";
import type { JsonObject } from "src/components/views/ai/assistant/uiContext/jsonTypes.ts";
import { configuratorErrorAgentData } from "src/components/views/erp/configurator/errors/configuratorErrorAgentData.ts";

export function knownApiErrorAgentData(error: KnownApiError): JsonObject {
	switch (error.type) {
		case "CONFIGURATOR_ERROR":
			return configuratorErrorAgentData(error);
	}
}
